import React from 'react';
import { COMPARE_LINK } from '../data/Localization';

/**
 * A button component used for comparing products.
 *
 * @component
 * @param {Object} props - The component props.
 * @param {Function} props.onClick - The click event handler for the button.
 * @returns {JSX.Element} The CompareButton component.
 */
const CompareButton = (props) => {
	return (
		<calcite-button
			class="prc__desc--compare"
			data-click="handleProdCompare"
			onClick={props.onClick}
			appearance="transparent"
			icon-end="check-circle"
			round="">
			<span>{COMPARE_LINK}</span>
		</calcite-button>
	);
};

export default CompareButton;
